package com.ervasstudio.tracoemovimento.pages.sobre

data class TeamMember(
    val imageSrc: String,
    val name: String,
    val role: String
)